export const getDay = (n = 0) => {
  const date = new Date();
  date.setDate(date.getDate() + n);
  return date;
};

export const yesterday = () => getDay(-1);
export const tomorrow = () => getDay(+1);

export const timeDiff = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  if (Number.isNaN(d1.getTime()) || Number.isNaN(d2.getTime())) {
    return undefined;
  }

  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  const diff = d1.getTime() - d2.getTime();
  const days = Math.floor(diff / day);
  const hours = Math.floor((diff % day) / hour);
  const minutes = Math.floor((diff % hour) / minute);
  const seconds = Math.floor((diff % minute) / second);
  const isNoTimeLeft = hours <= 0 && minutes <= 0 && seconds <= 0;

  const text = (() => {
    const parts = [];
    if (hours > 0) {
      parts.push(`${hours}h`);
    }
    if (minutes > 0) {
      parts.push(`${minutes}m`);
    }
    parts.push(`${seconds}s`);
    return parts.join(" ");
  })();

  return { days, hours, minutes, seconds, isNoTimeLeft, text };
};
